import { IUnserviceableInsurance, UNSERVICEABLE_INSURANCES } from "@/modules/onboarding/pages/insurance/constants";
import { CustomersInsuranceResponse, ICustomersInsuranceManualResponse, ICustomersInsuranceUploadResponse } from "../endpoints/customers";

export const filterInsurances = (insurances: CustomersInsuranceResponse[] = []) => (
    insurances.filter((item) => {
        const uploaded = !!(item as ICustomersInsuranceUploadResponse).front;
        const { payerName = '' } = (item as ICustomersInsuranceManualResponse)?.provider || {};
        
        return uploaded || !UNSERVICEABLE_INSURANCES[payerName.toLowerCase()];
    })
);

export const checkInsuranceProvider = (insurance: CustomersInsuranceResponse): IUnserviceableInsurance | null => {
    const uploadInsurance = insurance as ICustomersInsuranceUploadResponse;
    const manualInsurance = insurance as ICustomersInsuranceManualResponse;

    const provider = uploadInsurance.front
        ? uploadInsurance.addedInsurance?.provider
        : manualInsurance.provider;

    const { payerName = '' } = provider || {};

    return UNSERVICEABLE_INSURANCES[payerName.toLowerCase()] || null;
};

export const filterSupportedInsurances = (insurances: ICustomersInsuranceManualResponse[]) => (
    insurances?.filter((insurance) => {
        const conflict = checkInsuranceProvider(insurance);
        return !conflict;
    })
);